export interface ICompanyEditSaveAdminSuccess {
    id: string;
    rowId: string;
    message: string;
    refreshSessionState: boolean;
    styleChanged: boolean;
}

export class CompanyEditSaveAdminSuccess implements ICompanyEditSaveAdminSuccess {
    id: string;
    rowId: string;
    message: string;
    refreshSessionState: boolean;
    styleChanged: boolean;

    constructor();
    constructor(obj: ICompanyEditSaveAdminSuccess);
    constructor(obj?: any) {
        this.id = obj && obj.id || "";
        this.rowId = obj && obj.rowId || "";
        this.message = obj && obj.message || "";
        this.refreshSessionState = obj && obj.refreshSessionState || false;
        this.styleChanged = obj && obj.styleChanged || false;
    }
}